export enum HorizontalAlignment {
  Left = 'left',
  Right = 'right',
  Center = 'center',
  None = 'none',
}
